"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const SuppressedDefaultActionLink_1 = require("../../../SuppressedDefaultActionLink");
const Card_module_css_1 = __importDefault(require("./Card.module.css"));
const getBackgroundStyles = (backgroundUrl, backgroundSize = "contain") => backgroundUrl
    ? {
        backgroundSize,
        backgroundRepeat: "no-repeat",
        backgroundImage: `url(${backgroundUrl})`,
        backgroundColor: "#333333",
        backgroundPosition: "center top",
    }
    : {};
/**
 * Card component to be shared by all creator profiles
 */
function Card({ width, height, backgroundUrl, backgroundSize, link, logCardClick, children, }) {
    const sizeStyles = { width, height };
    const backgroundStyles = getBackgroundStyles(backgroundUrl, backgroundSize);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(SuppressedDefaultActionLink_1.SuppressedDefaultActionLink, { link: link, logMetric: logCardClick, children: (0, jsx_runtime_1.jsx)("div", { className: Card_module_css_1.default.cardContainer, style: { ...sizeStyles, ...backgroundStyles }, children: children }) }) }));
}
exports.Card = Card;
//# sourceMappingURL=Card.js.map